//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  components: {

  },
  props: ["operateList"],
  data() {
    return {
      isShow : true,
      ButtonList: [],
    };
  },

  mounted(){    
    if(!this.operateList) return;
    this.setData(this.operateList);
  },
  methods: {
    Show(){
      this.$show();
    },
    
    Hide(){
      this.$hide();
    },

    $show(){
      this.isShow = true;
    },

    $hide(){
      this.isShow = false;
    },

    $getThisForm(){
      return this.$parent;
    },

    $getActionObj(){
      try{
        console.log("this.$parent",this.$parent);
        var actionObj = this.$parent.$getActionObj();
        return actionObj;
      }catch(e){
        console.log("this.$e",e);
        return null;
      }      
    },

    setData(operateList) {
      if (!operateList) return;
      var buttonList = operateList.ButtonList;
      if (!buttonList || buttonList.length == 0) return;

      console.log("operateList",operateList);
      
      if(this.ButtonList.length > 0){
        this.ButtonList.splice(0,this.ButtonList.length);
      }

      var that = this;

      buttonList.forEach(m => {
        //var skinType = "primary";
        var skinType = "default";
        if (m.SkinType) {
          skinType = m.SkinType;
        }

        var buttonItem = {
          Type: skinType,
          Text: m.Text,
          DataItem: m,
          OnClick: async buttonItem => {
            var btnDataItem = buttonItem.DataItem;

            var actionObj = this.$getActionObj();
            await this.$cmd.ExecuteCmd(btnDataItem,actionObj);
          }
        };
        
        this.addButton(buttonItem);
      });
    },

    addButton(buttonItem) {
      var thisIndex = this.ButtonList.findIndex(
        m => m.Text == buttonItem
      );
      if (thisIndex != -1) {
        return;
      }
      this.ButtonList.push(buttonItem);
    },

    onButtonClick(buttonItem) {
      if (buttonItem && buttonItem.OnClick) {
        buttonItem.OnClick(buttonItem);
      }
    }
  }
};
